import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'

import { config } from '../config/config'
import type { User } from '../models'

export type UserStore = {
  user: User | null
  persist: boolean
  onRefreshTokenError?: (error: unknown) => void
  onInitError?: (error: unknown) => void
  onSignInError?: (error: unknown) => void
}

export const useUserStore = create<UserStore>()(
  immer(() => ({
    user: null,
    persist: true,
  })),
)

export async function setUser(user: User | null) {
  useUserStore.setState((draft) => {
    draft.user = user
  })

  if (useUserStore.getState().persist) {
    await config.getSaveKv()('user', JSON.stringify(user))
  }

  return user
}

export async function initUserStore() {
  if (!useUserStore.getState().persist) return

  const user = await config.getLoadKv()('user')
  if (!user) return

  try {
    await setUser(JSON.parse(user) as User | null)
  } catch (error) {
    useUserStore.getState().onInitError?.(error)
  }
}

export function useUser() {
  return useUserStore((v) => v.user)
}
